// @flow
import React, { useState } from "react";
import type { Node } from "react";
import classnames from "classnames";

import Styles from "./Input.module.scss";

type InputProps = {
  name: string,
  type: "text" | "email" | "tel" | "password | hidden",
  value: string,
  placeholder: ?string,
  onChange: Function,
  onClick?: Function,
  label?: Node,
  labelPosition?: "left" | "right",
  fullWidth?: boolean,
  error?: boolean,
  errorMessage?: string,
  className?: string,
  disabled?: boolean,
  autoComplete?: string,
  maxLength?: number,
};

const Input = ({
  name,
  type = "text",
  placeholder,
  value,
  onChange,
  label,
  labelPosition,
  fullWidth,
  error,
  errorMessage,
  className,
  disabled,
  autoComplete = "",
  maxLength = 50,
  onClick,
}: InputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={classnames(Styles.formField, className, { [Styles.fullWidth]: fullWidth })}>
      <div
        className={classnames(Styles.inputWrapper, labelPosition ? Styles[labelPosition] : Styles.right, {
          [Styles.withLabel]: label,
          [Styles.focus]: isFocused,
          [Styles.error]: error,
          [Styles.disabled]: disabled,
        })}
      >
        <input
          type={type}
          name={name}
          maxLength={maxLength}
          placeholder={placeholder}
          value={value}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={onChange}
          disabled={disabled}
          autoComplete={autoComplete}
          onClick={() => onClick && onClick()}
        />
        {label && <div className={Styles.label}>{label}</div>}
      </div>
      {errorMessage && <div className={Styles.errorMessage}>{errorMessage}</div>}
    </div>
  );
};

export default Input;
